import React, { useEffect, useReducer} from "react"
import Select from "react-select"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import _ from "lodash"

import { pureLocaleList } from "../util"

import * as Styles from "./IceBreakerSettingStyles"

const locales = [{ label: "Default", value: "default" }, ...pureLocaleList.map(locale => ({
  value: locale.value,
  label: locale.text
}))]

const INITIAL_STATE = {
  iceBreakers: [],
  localesOptions: locales
}

const reducer = (state, action) => {
  switch (action.type) {
    case "REFETCH_DATA":
      return {
        ...state,
        iceBreakers: action.payload
      }
    case "HANDLE_ICEBREAKERS":
      if (action.payload.type === "addIceBreaker") {

        const newObject = {
          call_to_actions: [
            {
              question: "",
              payload: ""
            }
          ],
          locale: "default"
        }

        return {
          ...state,
          iceBreakers: [
            ...state.iceBreakers,
            newObject
          ]
        }
      }

      if (action.payload.type === "removeIceBreaker") {
        const newArray = state.iceBreakers

        newArray.splice(action.payload.iceBreakerIndex, 1)

        return {
          ...state,
          iceBreakers: newArray
        }
      }
      if (action.payload.type === "addCallToAction") {
        const newArray = state.iceBreakers
        newArray[action.payload.iceBreakerIndex].call_to_actions.push(
          {
            question: "",
            payload: ""
          }
        )

        return {
          ...state,
          iceBreakers: newArray
        }
      }
      if (action.payload.type === "removeCallToAction") {
        const newArray = state.iceBreakers
        newArray[action.payload.iceBreakerIndex].call_to_actions.splice(action.payload.callToActionIndex, 1)

        return {
          ...state,
          iceBreakers: newArray
        }
      }
      if (action.payload.type === "onQuestionChange") {
        const value = action.payload.value
        const newArray = state.iceBreakers
        newArray[action.payload.iceBreakerIndex].call_to_actions[action.payload.callToActionIndex].question = value

        return {
          ...state,
          iceBreakers: newArray
        }
      }
      if (action.payload.type === "onPayloadChange") {
        const value = action.payload.value
        const newArray = state.iceBreakers
        newArray[action.payload.iceBreakerIndex].call_to_actions[action.payload.callToActionIndex].payload = value

        return {
          ...state,
          iceBreakers: newArray
        }
      }
      if (action.payload.type === "changeLocale") {
        const value = action.payload.value
        const newArray = state.iceBreakers
        newArray[action.payload.iceBreakerIndex].locale = value

        return {
          ...state,
          localesOptions: state.localesOptions.filter(i => i.value !== action.payload.value),
          iceBreakers: newArray
        }
      }
      return state
    default:
      throw new Error(`none exist action type: ${action.type}`)
  }
}

const IceBreakerSetting = ({
  onChange,
  value
}) => {
  const [variables, dispatch] = useReducer(reducer, INITIAL_STATE)

  useEffect(() => {
    if (!_.isEmpty(value)) {
      const array = value
      dispatch({
        type: "REFETCH_DATA",
        payload: array
      })
    }
  }, [JSON.stringify(value)])

  useEffect(() => {

    onChange(variables.iceBreakers)
    console.log("variables.iceBreakers", variables.iceBreakers)

  }, [JSON.stringify(variables.iceBreakers)])

  const canAdd = (iceBreaker) => {
    if (iceBreaker.call_to_actions.length >= 4) {
      return false
    }
    return true
  }
  return (
    <>
      <Styles.LocaleButtonContainer>
        <h4>
          Locales
        </h4>
        <Styles.StyledButton
          className="add-button"
          type="button"
          onClick={() => {
            dispatch({
              type: "HANDLE_ICEBREAKERS",
              payload: {
                type: "addIceBreaker"
              }
            })
          }}
        >
          + Additional Locale
        </Styles.StyledButton>
      </Styles.LocaleButtonContainer>
      {variables?.iceBreakers.map((iceBreaker, index) => (
        <Styles.IceBreakerContainer>
          <Styles.LeftContainer>
            <Styles.FakeIGWrapper>
              <Styles.IGHeader />
              <Styles.IGBody>
                {iceBreaker?.call_to_actions?.map(iceBreakerQuestion => (
                  <Styles.IceBreakerBubble>
                    {iceBreakerQuestion.question}
                  </Styles.IceBreakerBubble>
                ))}
              </Styles.IGBody>
              <Styles.IGFooter>
                <Styles.IGINput>
                  Message...
                </Styles.IGINput>
                <Styles.IGSendButton>
                  Send
                </Styles.IGSendButton>
              </Styles.IGFooter>
            </Styles.FakeIGWrapper>
          </Styles.LeftContainer>
          <Styles.RightContainer>
            <Styles.LocaleContainer>
              <Styles.LocaleActionContainer
                disabled={!canAdd(iceBreaker)}
              >
                <Select
                  isDisabled={_.isEmpty(iceBreaker.call_to_actions)}
                  styles={{
                    container: provided => ({
                      ...provided,
                      width: "300px",
                    }),
                    menuList: provided => ({
                      ...provided,
                      height: iceBreaker.call_to_actions.length > 1 ? "300px" : "142px"
                    }),
                  }}
                  value={locales.find((i) => i.value === iceBreaker.value)}
                  options={variables.localesOptions}
                  onChange={(value) => {
                    dispatch({
                      type: "HANDLE_ICEBREAKERS",
                      payload: {
                        type: "changeLocale",
                        iceBreakerIndex: index,
                        value: value.value
                      }
                    })

                  }}
                />
                <div className="button-group">
                  <div
                    className="remove-button"
                    onClick={() => {
                      dispatch({
                        type: "HANDLE_ICEBREAKERS",
                        payload: {
                          type: "removeIceBreaker",
                          iceBreakerIndex: index
                        }
                      })
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <FontAwesomeIcon
                      className="remove-button-icon"
                      icon={faTrashAlt}
                    />

                  </div>
                  <div
                    className="add-button"
                    onClick={() => {
                      if (!canAdd(iceBreaker)) {
                        return
                      }
                      dispatch({
                        type: "HANDLE_ICEBREAKERS",
                        payload: {
                          type: "addCallToAction",
                          iceBreakerIndex: index
                        }
                      })
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <FontAwesomeIcon
                      className="add-button-icon"
                      icon={faPlus}
                      data-tip="A maximum of 4 questions can be set in one locale"
                      data-for={`disabled_add_question + ${index}`}
                    />

                  </div>

                </div>

              </Styles.LocaleActionContainer>

              {iceBreaker.call_to_actions.map((callToAction, callToActionIndex) => (
                <Styles.InputWrapper key={callToAction + callToActionIndex}>
                  <div className="text-field-container">
                    <Styles.StyledTextField
                      placeholder="Question..."
                      value={callToAction?.question}
                      onChange={(i) => {
                        dispatch({
                          type: "HANDLE_ICEBREAKERS",
                          payload: {
                            type: "onQuestionChange",
                            value: i.target.value,
                            iceBreakerIndex: index,
                            callToActionIndex
                          }
                        })
                      }}
                    />
                    <Styles.StyledTextField
                      placeholder="Payload..."
                      value={callToAction?.payload}
                      onChange={(i) => {
                        dispatch({
                          type: "HANDLE_ICEBREAKERS",
                          payload: {
                            type: "onPayloadChange",
                            value: i.target.value,
                            iceBreakerIndex: index,
                            callToActionIndex
                          }
                        })
                      }}
                    />
                  </div>
                  <div className="input-button-container">
                    <div
                      className="remove-button"
                      onClick={() => {
                        dispatch({
                          type: "HANDLE_ICEBREAKERS",
                          payload: {
                            type: "removeCallToAction",
                            iceBreakerIndex: index,
                            callToActionIndex
                          }
                        })
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <FontAwesomeIcon
                        className="remove-button-icon"
                        icon={faTrashAlt}
                      />

                    </div>
                  </div>
                </Styles.InputWrapper>
              ))}
            </Styles.LocaleContainer>
          </Styles.RightContainer>
          {!canAdd(iceBreaker) && (
            <Styles.StyledTooltip
              effect="solid"
              id={`disabled_add_question + ${index}`}
              offset={{ right: 36, top: 36, }}
              place="top"
            />
          )}
        </Styles.IceBreakerContainer>
      ))}
      
    </>
  )
}

export default IceBreakerSetting
